import { createAction } from '@reduxjs/toolkit';
import { RequestError, Callback } from 'types';
import { State } from './types';

export const fetchSections = createAction('sections/fetch', (callback?: Callback<unknown, void>) => ({
  payload: undefined,
  meta: { callback },
}));

export const fetchedSections = createAction('sections/fetched', (data?: State['data'], error?: RequestError) => ({
  payload: error || data,
  error: Boolean(error),
}));

export default {
  fetchSections,
  fetchedSections,
};
